//CREATE_COMPANY
export const ADMIN_CREATE_COMPANY_REQUEST = "ADMIN_CREATE_COMPANY_REQUEST";
export const ADMIN_CREATE_COMPANY_SUCCESS = "ADMIN_CREATE_COMPANY_SUCCESS";
export const ADMIN_CREATE_COMPANY_FAIL = "ADMIN_CREATE_COMPANY_FAIL";

//ADD_COMPANY_MODULES
export const ADMIN_ADD_COMPANY_MODULES_REQUEST =
  "ADMIN_ADD_COMPANY_MODULES_REQUEST";
export const ADMIN_ADD_COMPANY_MODULES_SUCCESS =
  "ADMIN_ADD_COMPANY_MODULES_SUCCESS";
export const ADMIN_ADD_COMPANY_MODULES_FAIL = "ADMIN_ADD_COMPANY_MODULES_FAIL";

//UPDATE_DETAIL_COMPANY
export const ADMIN_UPDATE_COMPANY_DETAIL_REQUEST =
  "ADMIN_UPDATE_COMPANY_DETAIL_REQUEST";
export const ADMIN_UPDATE_COMPANY_DETAIL_SUCCESS =
  "ADMIN_UPDATE_COMPANY_DETAIL_SUCCESS";
export const ADMIN_UPDATE_COMPANY_DETAIL_FAIL =
  "ADMIN_UPDATE_COMPANY_DETAIL_FAIL";

// //ADMIN_ADD_MODULES_IN_COMPANY
// export const ADMIN_ADD_MODULES_IN_COMPANY_REQUEST =
//   "ADMIN_ADD_MODULES_IN_COMPANY_REQUEST";
// export const ADMIN_ADD_MODULES_IN_COMPANY_SUCCESS =
//   "ADMIN_ADD_MODULES_IN_COMPANY_SUCCESS";
// export const ADMIN_ADD_MODULES_IN_COMPANY_FAIL =
//   "ADMIN_ADD_MODULES_IN_COMPANY_FAIL";

//UPDATE_DEPARTMENT
export const ADMIN_UPDATE_DEPARTMENT_REQUEST =
  "ADMIN_UPDATE_DEPARTMENT_REQUEST";
export const ADMIN_UPDATE_DEPARTMENT_SUCCESS =
  "ADMIN_UPDATE_DEPARTMENT_SUCCESS";
export const ADMIN_UPDATE_DEPARTMENT_FAIL = "ADMIN_UPDATE_DEPARTMENT_FAIL";

//TEAM_DEPARTMENT
export const ADMIN_TEAM_UPDATE_REQUEST = "ADMIN_TEAM_UPDATE_REQUEST";
export const ADMIN_TEAM_UPDATE_SUCCESS = "ADMIN_TEAM_UPDATE_SUCCESS";
export const ADMIN_TEAM_UPDATE_FAIL = "ADMIN_TEAM_UPDATE_FAIL";

//UPDATE_LOGO_COMPANY
export const ADMIN_UPDATE_COMPANY_LOGO_REQUEST =
  "ADMIN_UPDATE_COMPANY_LOGO_REQUEST";
export const ADMIN_UPDATE_COMPANY_LOGO_SUCCESS =
  "ADMIN_UPDATE_COMPANY_LOGO_SUCCESS";
export const ADMIN_UPDATE_COMPANY_LOGO_FAIL = "ADMIN_UPDATE_COMPANY_LOGO_FAIL";

//INVITE_EMAIL
export const ADMIN_INVITE_BY_EMAIL_REQUEST = "ADMIN_INVITE_BY_EMAIL_REQUEST";
export const ADMIN_INVITE_BY_EMAIL_SUCCESS = "ADMIN_INVITE_BY_EMAIL_SUCCESS";
export const ADMIN_INVITE_BY_EMAIL_FAIL = "ADMIN_INVITE_BY_EMAIL_FAIL";

//DEPARTMENT_LIST
export const ADMIN_DEPARTMENT_LIST_REQUEST = "ADMIN_DEPARTMENT_LIST_REQUEST";
export const ADMIN_DEPARTMENT_LIST_SUCCESS = "ADMIN_DEPARTMENT_LIST_SUCCESS";
export const ADMIN_DEPARTMENT_LIST_FAIL = "ADMIN_DEPARTMENT_LIST_FAIL";

//GET_USER_FROM_DEPARTMENT_LIST
export const ADMIN_GET_USER_FROM_DEPART_LIST_REQUEST =
  "ADMIN_GET_USER_FROM_DEPART_LIST_REQUEST";
export const ADMIN_GET_USER_FROM_DEPART_LIST_SUCCESS =
  "ADMIN_GET_USER_FROM_DEPART_LIST_SUCCESS";
export const ADMIN_GET_USER_FROM_DEPART_LIST_FAIL =
  "ADMIN_GET_USER_FROM_DEPART_LIST_FAIL";

//ADD_DEPARTMENT_LIST
export const ADMIN_ADD_DEPARTMENT_LIST_REQUEST =
  "ADMIN_ADD_DEPARTMENT_LIST_REQUEST";
export const ADMIN_ADD_DEPARTMENT_LIST_SUCCESS =
  "ADMIN_ADD_DEPARTMENT_LIST_SUCCESS";
export const ADMIN_ADD_DEPARTMENT_LIST_FAIL = "ADMIN_ADD_DEPARTMENT_LIST_FAIL";

//ADD_USER_IN_DEPARTMENT_LIST
export const ADMIN_ADD_USER_IN_DEPARTMENT_LIST_REQUEST =
  "ADMIN_ADD_USER_IN_DEPARTMENT_LIST_REQUEST";
export const ADMIN_ADD_USER_IN_DEPARTMENT_LIST_SUCCESS =
  "ADMIN_ADD_USER_IN_DEPARTMENT_LIST_SUCCESS";
export const ADMIN_ADD_USER_IN_DEPARTMENT_LIST_FAIL =
  "ADMIN_ADD_USER_IN_DEPARTMENT_LIST_FAIL";

//DELETE_DEPARTMENT_LIST
export const ADMIN_DELETE_DEPARTMENT_LIST_REQUEST =
  "ADMIN_DELETE_DEPARTMENT_LIST_REQUEST";
export const ADMIN_DELETE_DEPARTMENT_LIST_SUCCESS =
  "ADMIN_DELETE_DEPARTMENT_LIST_SUCCESS";
export const ADMIN_DELETE_DEPARTMENT_LIST_FAIL =
  "ADMIN_DELETE_DEPARTMENT_LIST_FAIL";

//ADD_GOALS_LIST
export const ADMIN_ADD_GOALS_REQUEST = "ADMIN_ADD_GOALS_REQUEST";
export const ADMIN_ADD_GOALS_SUCCESS = "ADMIN_ADD_GOALS_SUCCESS";
export const ADMIN_ADD_GOALS_FAIL = "ADMIN_ADD_GOALS_FAIL";

//ACTIVE_SUBSCRIPTION
export const ADMIN_ACTIVE_SUBSCRIPTION_REQUEST =
  "ADMIN_ACTIVE_SUBSCRIPTION_REQUEST";
export const ADMIN_ACTIVE_SUBSCRIPTION_SUCCESS =
  "ADMIN_ACTIVE_SUBSCRIPTION_SUCCESS";
export const ADMIN_ACTIVE_SUBSCRIPTION_FAIL = "ADMIN_ACTIVE_SUBSCRIPTION_FAIL";

//TRAIL_SUBSCRIPTION
export const ADMIN_TRAIL_SUBSCRIPTION_REQUEST =
  "ADMIN_TRAIL_SUBSCRIPTION_REQUEST";
export const ADMIN_TRAIL_SUBSCRIPTION_SUCCESS =
  "ADMIN_TRAIL_SUBSCRIPTION_SUCCESS";
export const ADMIN_TRAIL_SUBSCRIPTION_FAIL = "ADMIN_TRAIL_SUBSCRIPTION_FAIL";

//ADD_JOB_BOARD_LINK
export const ADD_JOB_BOARD_LINK_REQUEST = "ADD_JOB_BOARD_LINK_REQUEST";
export const ADD_JOB_BOARD_LINK_SUCCESS = "ADD_JOB_BOARD_LINK_SUCCESS";
export const ADD_JOB_BOARD_LINK_FAIL = "ADD_JOB_BOARD_LINK_FAIL";

//GET_JOB_BOARD_LINK
export const GET_JOB_BOARD_LINK_REQUEST = "GET_JOB_BOARD_LINK_REQUEST";
export const GET_JOB_BOARD_LINK_SUCCESS = "GET_JOB_BOARD_LINK_SUCCESS";
export const GET_JOB_BOARD_LINK_FAIL = "GET_JOB_BOARD_LINK_FAIL";

//LEAVE_CATEGORY_IMPORT
export const LEAVE_CATEGORY_IMPORT_REQUEST = "LEAVE_CATEGORY_IMPORT_REQUEST";
export const LEAVE_CATEGORY_IMPORT_SUCCESS = "LEAVE_CATEGORY_IMPORT_SUCCESS";
export const LEAVE_CATEGORY_IMPORT_FAIL = "LEAVE_CATEGORY_IMPORT_FAIL";

//USER_QUOTA_IMPORT
export const USER_QUOTA_IMPORT_REQUEST = "USER_QUOTA_IMPORT_REQUEST";
export const USER_QUOTA_IMPORT_SUCCESS = "USER_QUOTA_IMPORT_SUCCESS";
export const USER_QUOTA_IMPORT_FAIL = "USER_QUOTA_IMPORT_FAIL";
//ADVANCED_USER_QUOTA_IMPORT
export const ADVANCED_USER_QUOTA_IMPORT_REQUEST =
  "ADVANCED_USER_QUOTA_IMPORT_REQUEST";
export const ADVANCED_USER_QUOTA_IMPORT_SUCCESS =
  "ADVANCED_USER_QUOTA_IMPORT_SUCCESS";
export const ADVANCED_USER_QUOTA_IMPORT_FAIL =
  "ADVANCED_USER_QUOTA_IMPORT_FAIL";

//ADVANCED_USER_QUOTA_IMPORT
// export const ADVANCED_USER_QUOTA_IMPORT_REQUEST =
//   "ADVANCED_USER_QUOTA_IMPORT_REQUEST";
// export const ADVANCED_USER_QUOTA_IMPORT_SUCCESS =
//   "ADVANCED_USER_QUOTA_IMPORT_SUCCESS";
// export const ADVANCED_USER_QUOTA_IMPORT_FAIL =
//   "ADVANCED_USER_QUOTA_IMPORT_FAIL";

//SHIFT_IMPORT
export const SHIFT_IMPORT_REQUEST = "SHIFT_IMPORT_REQUEST";
export const SHIFT_IMPORT_SUCCESS = "SHIFT_IMPORT_SUCCESS";
export const SHIFT_IMPORT_FAIL = "SHIFT_IMPORT_FAIL";

//PAYROLL_IMPORT
export const PAYROLL_IMPORT_REQUEST = "PAYROLL_IMPORT_REQUEST";
export const PAYROLL_IMPORT_SUCCESS = "PAYROLL_IMPORT_SUCCESS";
export const PAYROLL_IMPORT_FAIL = "PAYROLL_IMPORT_FAIL";

//SEND_HR_LETTER
export const SEND_HR_LETTER_REQUEST = "SEND_HR_LETTER_REQUEST";
export const SEND_HR_LETTER_SUCCESS = "SEND_HR_LETTER_SUCCESS";
export const SEND_HR_LETTER_FAIL = "SEND_HR_LETTER_FAIL";

//GET_HR_LETTERS
export const GET_HR_LETTERS_REQUEST = "GET_HR_LETTERS_REQUEST";
export const GET_HR_LETTERS_SUCCESS = "GET_HR_LETTERS_SUCCESS";
export const GET_HR_LETTERS_FAIL = "GET_HR_LETTERS_FAIL";

//GET_COMPANY_APPS
export const GET_COMPANY_APPS_REQUEST = "GET_COMPANY_APPS_REQUEST";
export const GET_COMPANY_APPS_SUCCESS = "GET_COMPANY_APPS_SUCCESS";
export const GET_COMPANY_APPS_FAIL = "GET_COMPANY_APPS_FAIL";
export const UPDATE_COMPANY_APPS_LOCAL = "UPDATE_COMPANY_APPS_LOCAL";

//GET_ALLOWED_APPS
export const GET_ALLOWED_APPS_REQUEST = "GET_ALLOWED_APPS_REQUEST";
export const GET_ALLOWED_APPS_SUCCESS = "GET_ALLOWED_APPS_SUCCESS";
export const GET_ALLOWED_APPS_FAIL = "GET_ALLOWED_APPS_FAIL";

//SAVE_COMPANY_APPS
export const SAVE_COMPANY_APPS_REQUEST = "SAVE_COMPANY_APPS_REQUEST";
export const SAVE_COMPANY_APPS_SUCCESS = "SAVE_COMPANY_APPS_SUCCESS";
export const SAVE_COMPANY_APPS_FAIL = "SAVE_COMPANY_APPS_FAIL";
